"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
}

const Landing = ({
  user = {
    access: []
  }
}) => {
  const redirectTo = user.access != null && user.access.includes('viewTriagePage') ? '/analysis/insights' : '/actions';
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    to: redirectTo
  });
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Landing);

exports.default = _default;
module.exports = exports.default;